// 配置默认页面值
export const DEFAULT_PAGE_ID = 'page-home';

// 路由高亮映射
export const PAGE_SIDEBAR_MAP = {
    'page-home': 'home',
    'page-search': 'home',
    'page-office': 'office',
    'page-activation': 'activation',
    'page-install': 'install',
    'page-plugins': 'ai-lobster',
    'page-tips': 'tips',
    'page-products': 'office',
    'page-purchase': 'activation',
    'page-ai-lobster': 'ai-lobster',
    'page-ai-lobster-detail': 'ai-lobster',
    'page-orders': 'orders',
    'page-plugins-mine': 'plugins-mine',
    'page-help': 'help',
    'page-contact': 'contact',
    'page-step2-activation': 'activation',
    'page-step3-install': 'install',
    'page-activate-key': 'activation',
    'page-disk-clean': 'disk-clean',
    'page-image-viewer': 'image-viewer',
    'page-compress': 'compress',
    'page-pdf-tools': 'pdf-tools',
    'page-plugin-plaza': 'plugin-plaza'
};

export const INSTALL_PROGRESS_STEPS = [
    {
        icon: '⬇️',
        text: '正在下载安装包…',
        detail: 'Microsoft_Office_Setup.exe · 1.24 GB',
        subSteps: [
            { pct: 8, label: '连接微软服务器…' },
            { pct: 22, label: '下载中 22%…' },
            { pct: 45, label: '下载中 45%…' },
            { pct: 68, label: '下载中 68%…' },
            { pct: 88, label: '下载中 88%…' },
            { pct: 100, label: '下载完成 ✓' },
        ],
        duration: 4000,
    },
    {
        icon: '⚙️',
        text: '正在安装 Office 核心组件…',
        detail: 'Word · Excel · PowerPoint · Outlook · OneNote',
        subSteps: [
            { pct: 5, label: '解压安装包…' },
            { pct: 20, label: '安装 Word…' },
            { pct: 38, label: '安装 Excel…' },
            { pct: 55, label: '安装 PowerPoint…' },
            { pct: 72, label: '安装 Outlook…' },
            { pct: 88, label: '安装 OneNote…' },
            { pct: 100, label: '组件安装完成 ✓' },
        ],
        duration: 5000,
    },
];
// AiPPT 插件记录（「已安装插件」页数据源）。
// 这条记录的内容本来就是前端造的，没有后端来源，所以固定成死数据：
// 展示与是否写入 c 端存储都以「本机是否装了 AiPPT」（client_check_apippt）为准。
// 这样即使用户卸载 workai 丢了 c 端存储、但 AiPPT 还在机器上，重装后也能自动恢复这条记录。
export const AIPPT_PLUGIN_RECORD = {
    product: 'AiPPT',
    ico: new URL('@/assets/office/plugin_aippt.png', import.meta.url).href,
    devices: 1,
};
// 产品列表映射字段
export const extraFieldMap = {
    "office365_server": {
        name: "Microsoft 365 激活服务",
        ico: new URL("@/assets/office/office_code_family.png", import.meta.url).href,
        subtitle: "云端订阅·最新功能·含1TB OneDrive存储",
        unit: "激活设备有效期1年",
        orig: 298,
        features: ['全套 Office 应用 + 实时更新', '1TB OneDrive云存储', '内置AiPPT功能', '随时取消订阅']
    },
    "office365_personal": {
        name: "Microsoft 365 个人版",
        ico: new URL("@/assets/office/office_code_only.png", import.meta.url).href,
        subtitle: "经典版本，适合全场景办公",
        unit: "激活设备有效期1年",
        orig: 498,
        features: ['Word / Excel / Powerpoint', '最多5台设备同时使用', 'OneNote / Outlook', '正版序列号，即时发货'],
    },
    // "office365_month": {
    //     name: "Microsoft 365 激活服务 1月版",
    //     ico: new URL("@/assets/office/office_code_only.png", import.meta.url).href,
    //     subtitle: "经典版本，适合全场景办公",
    //     unit: "激活设备有效期1个月",
    //     orig: 58,
    //     features: ['Word / Excel / Powerpoint', '最多5台设备同时使用', 'OneNote / Outlook', '正版序列号，即时发货'],
    // },
    // "office365_3month": {
    //     name: "Microsoft 365 激活服务 3月版",
    //     ico: new URL("@/assets/office/office_code_only.png", import.meta.url).href,
    //     subtitle: "经典版本，适合全场景办公",
    //     unit: "激活设备有效期3个月",
    //     orig: 98.8,
    //     features: ['Word / Excel / Powerpoint', '最多5台设备同时使用', 'OneNote / Outlook', '正版序列号，即时发货'],
    // },
    // 测试产品
    "office365_family_split_168": {
        name: "测试产品",
        ico: new URL("@/assets/office/office_code_family.png", import.meta.url).href,
        subtitle: "云端订阅·最新功能·含1TB OneDrive存储",
        unit: "激活设备有效期1年",
        orig: 1,
        features: ['全套 Office 应用 + 实时更新', '1TB OneDrive云存储', '内置AiPPT功能', '随时取消订阅']
    }
}
// 全部快捷技巧
export const Tips_List = [
    {
        type: 'Word',
        title: '加粗',
        desc: '让文字更醒目，常用于标题或重点词',
        codes: ['Ctrl', 'B']
    },
    {
        type: 'Word',
        title: '斜体',
        desc: '用于书名、术语或需要强调的外文词汇',
        codes: ['Ctrl', 'I']
    },
    {
        type: 'Word',
        title: '下划线',
        desc: '快速给文字加下划线，适合标注关键信息',
        codes: ['Ctrl', 'U']
    },
    {
        type: 'Word',
        title: '只给文字加下划线',
        desc: '下划线不延伸到空格，排版更干净',
        codes: ['Ctrl', 'Shift', 'W']
    },
    {
        type: 'Word',
        title: '双下划线',
        desc: '比普通下划线更突出，适合特殊标注',
        codes: ['Ctrl', 'Shift', 'D']
    },
    {
        type: 'Word',
        title: '字号减小/增大',
        desc: '每按一次调整1pt，比手动输入更精确快速',
        codes: ['Ctrl', '[ / ]']
    },
    {
        type: 'Word',
        title: '切换大小写',
        desc: '在全大写、全小写、首字母大写间循环切换',
        codes: ['Shift', 'F3']
    },
    {
        type: 'Word',
        title: '复制/粘贴格式',
        desc: '把一处的字体颜色、大小等格式快速套用到其他文字',
        codes: ['Ctrl', 'Shift', 'C/V']
    },
    {
        type: 'Word',
        title: '重复上一步操作',
        desc: '刚做了插入表格、改颜色等操作，按F4立即再做一次',
        codes: ['F4']
    },
    {
        type: 'Word',
        title: '查找替换',
        desc: '批量修改文中某个词或格式，长文档必备',
        codes: ['Ctrl', 'H']
    },
    {
        type: 'Word',
        title: '居中/左/右/两端对齐',
        desc: '快速调整段落对齐方式，无需点菜单',
        codes: ['Ctrl', 'E/L/R/J']
    },
    {
        type: 'Word',
        title: '单倍/双倍/1.5倍行距',
        desc: '快速调整段落疏密，改善阅读体验',
        codes: ['Ctrl', '1/2/5']
    },
    {
        type: 'Word',
        title: '上下移动段落',
        desc: '调整段落顺序时不用剪切粘贴，直接挪位置',
        codes: ['Alt', 'Shift', '↑/↓']
    },
    {
        type: 'Word',
        title: '跳到文档首/尾',
        desc: '长文档中瞬间定位，不用滚动滚动条',
        codes: ['Ctrl', 'Home/End']
    },
    {
        type: 'Word',
        title: '按词移动光标',
        desc: '比逐字移动快得多，精准定位到某个词',
        codes: ['Ctrl', '←/→']
    },
    {
        type: 'Word',
        title: '按词选中文字',
        desc: '快速选中一个词或一段连续词组',
        codes: ['Ctrl', 'Shift', '←/→']
    },
    {
        type: 'Word',
        title: '选中到文档首/尾',
        desc: '从当前位置一键选中到文档开头或结尾',
        codes: ['Ctrl', 'Shift', 'Home/End']
    },
    {
        type: 'Word',
        title: '全选',
        desc: '选中文档所有内容，配合格式操作很高效',
        codes: ['Ctrl', 'A']
    },
    {
        type: 'Word',
        title: '删除前一个词',
        desc: '比按多次退格键快，写错一个词直接删掉',
        codes: ['Ctrl', 'Backspace']
    },
    {
        type: 'Word',
        title: '删除后一个词',
        desc: '向后删除整个词，修改文字时更高效',
        codes: ['Ctrl', 'Delete']
    },
    {
        type: 'Word',
        title: '插入分页符',
        desc: '强制从下一页开始，比连续按回车更规范',
        codes: ['Ctrl', 'Enter']
    },
    {
        type: 'Word',
        title: '插入当前日期',
        desc: '自动插入系统日期，写报告、合同时省时',
        codes: ['Alt', 'Shift', 'D']
    },
    {
        type: 'Word',
        title: '插入超链接',
        desc: '快速给选中文字添加网页或文件链接',
        codes: ['Ctrl', 'K']
    },
    {
        type: 'Word',
        title: '应用正文样式',
        desc: '一键清除标题等样式，还原为正文格式',
        codes: ['Ctrl', 'Shift', 'N']
    },
    {
        type: 'Word',
        title: '应用标题1/2/3样式',
        desc: '快速套用标题层级，自动生成目录时必用',
        codes: ['Ctrl', 'Alt', '1/2/3']
    },
    {
        type: 'Word',
        title: '列表增加/减少缩进',
        desc: '在项目符号列表中调整层级，做大纲很方便',
        codes: ['Tab / Shift+Tab']
    },
    {
        type: 'Word',
        title: '字号按级别增大/减小',
        desc: '按Word预设字号档位调整，跳变比Ctrl+[]幅度大',
        codes: ['Ctrl', 'Shift', '>/<']
    },
    {
        type: 'Word',
        title: '拼写检查',
        desc: '扫描全文拼写与语法错误，提交前必查',
        codes: ['F7']
    },
    {
        type: 'Word',
        title: '同义词库',
        desc: '选中某词后调出近义词，避免用词重复',
        codes: ['Shift', 'F7']
    },
    {
        type: 'Word',
        title: '打开字号输入框',
        desc: '直接输入任意字号数值，比下拉列表更自由',
        codes: ['Ctrl', 'Shift', 'P']
    },
    {
        type: 'Excel',
        title: '多单元格同时输入',
        desc: '先选中多个单元格，输入后按此键，全部填入相同内容',
        codes: ['Ctrl', 'Enter']
    },
    {
        type: 'Excel',
        title: '插入当前日期',
        desc: '直接输入今天日期，不随时间变化（静态值）',
        codes: ['Ctrl', ';']
    },
    {
        type: 'Excel',
        title: '插入当前时间',
        desc: '同上，记录当前时刻，不会自动更新',
        codes: ['Ctrl', 'Shift', ';']
    },
    {
        type: 'Excel',
        title: '单元格内换行',
        desc: '在一个单元格内分行显示内容，不跳到下一格',
        codes: ['Alt', 'Enter']
    },
    {
        type: 'Excel',
        title: '向下/向右填充',
        desc: '将第一行/列的内容或公式复制填充到选中区域',
        codes: ['Ctrl', 'D/R']
    },
    {
        type: 'Excel',
        title: '自动求和',
        desc: '自动识别上方或左侧数据范围，一键插入SUM公式',
        codes: ['Alt', '=']
    },
    {
        type: 'Excel',
        title: '创建智能表格',
        desc: '数据区域转为表格，自动带筛选、格式和扩展引用',
        codes: ['Ctrl', 'T']
    },
    {
        type: 'Excel',
        title: '打开单元格格式对话框',
        desc: '快速设置数字格式、边框、填充等所有格式选项',
        codes: ['Ctrl', '1']
    },
    {
        type: 'Excel',
        title: '进入单元格编辑模式',
        desc: '双击效果一样，但键盘操作更快，可直接修改公式',
        codes: ['F2']
    },
    {
        type: 'Excel',
        title: '开启/关闭筛选',
        desc: '给表头行快速添加或取消下拉筛选按钮',
        codes: ['Ctrl', 'Shift', 'L']
    },
    {
        type: 'Excel',
        title: '跳到数据区域边缘',
        desc: '瞬间定位到连续数据的最后一行或一列',
        codes: ['Ctrl', '↑/↓/←/→']
    },
    {
        type: 'Excel',
        title: '选中到数据最后一格',
        desc: '从当前单元格选中到整个数据区域的右下角',
        codes: ['Ctrl', 'Shift', 'End']
    },
    {
        type: 'Excel',
        title: '选中到A1',
        desc: '从当前单元格向左上角选中到A1，常用于全选数据',
        codes: ['Ctrl', 'Shift', 'Home']
    },
    {
        type: 'Excel',
        title: '选中当前数据区域',
        desc: '自动识别并选中光标所在的连续数据块',
        codes: ['Ctrl', '*']
    },
    {
        type: 'Excel',
        title: '选中整列',
        desc: '无需点列标，快速选中光标所在整列',
        codes: ['Ctrl', '空格']
    },
    {
        type: 'Excel',
        title: '选中整行',
        desc: '快速选中光标所在整行，配合插入/删除行使用',
        codes: ['Shift', '空格']
    },
    {
        type: 'Excel',
        title: '插入行/列',
        desc: '选中行/列后直接插入，不用右键菜单',
        codes: ['Ctrl', 'Shift', '+']
    },
    {
        type: 'Excel',
        title: '删除行/列',
        desc: '选中行/列后直接删除，比右键更快',
        codes: ['Ctrl', '-']
    },
    {
        type: 'Excel',
        title: '应用常规格式',
        desc: '清除数字、日期等特殊格式，还原为默认显示',
        codes: ['Ctrl', 'Shift', '~']
    },
    {
        type: 'Excel',
        title: '应用货币格式',
        desc: '一键给数字加上货币符号和两位小数',
        codes: ['Ctrl', 'Shift', '$']
    },
    {
        type: 'Excel',
        title: '应用百分比格式',
        desc: '数字乘以100并加%号，财务表格常用',
        codes: ['Ctrl', 'Shift', '%']
    },
    {
        type: 'Excel',
        title: '应用日期格式',
        desc: '将数字转为日期显示，如44927→2023/1/1',
        codes: ['Ctrl', 'Shift', '#']
    },
    {
        type: 'Excel',
        title: '应用时间格式',
        desc: '将小数转为时间显示，如0.5→12:00',
        codes: ['Ctrl', 'Shift', '@']
    },
    {
        type: 'Excel',
        title: '切换绝对/相对引用',
        desc: '编辑公式时在$A$1、A$1、$A1、A1间循环切换',
        codes: ['F4']
    },
    {
        type: 'Excel',
        title: '显示/隐藏公式',
        desc: '切换单元格显示公式本身还是计算结果，排查错误必用',
        codes: ['Ctrl', '`']
    },
    {
        type: 'Excel',
        title: '跳转到公式引用的单元格',
        desc: '追踪公式来源，快速定位被引用的数据位置',
        codes: ['Ctrl', '[']
    },
    {
        type: 'Excel',
        title: '显示列的下拉列表',
        desc: '自动列出该列已有的值，快速填入重复内容',
        codes: ['Alt', '↓']
    },
    {
        type: 'Excel',
        title: '切换工作表',
        desc: '多Sheet文件中快速翻页，不用鼠标点标签',
        codes: ['Ctrl', 'PageUp/Down']
    },
    {
        type: 'Excel',
        title: '生成图表到新工作表',
        desc: '选中数据后一键生成独立图表页，适合大图展示',
        codes: ['F11']
    },
    {
        type: 'Excel',
        title: '生成图表到当前工作表',
        desc: '在当前Sheet内嵌入图表，数据与图表并排查看',
        codes: ['Alt', 'F1']
    },
    {
        type: 'PPT',
        title: '从头放映',
        desc: '无论当前在第几页，都从第一页开始播放',
        codes: ['F5']
    },
    {
        type: 'PPT',
        title: '从当前页放映',
        desc: '直接预览当前编辑的这一页，调试动画很常用',
        codes: ['Shift', 'F5']
    },
    {
        type: 'PPT',
        title: '退出放映',
        desc: '随时中断放映，返回编辑状态',
        codes: ['Esc']
    },
    {
        type: 'PPT',
        title: '放映时黑屏',
        desc: '演讲暂停时遮挡画面，让观众注意力回到你身上',
        codes: ['B']
    },
    {
        type: 'PPT',
        title: '放映时白屏',
        desc: '与黑屏效果相同，视场地光线选择使用',
        codes: ['W']
    },
    {
        type: 'PPT',
        title: '放映时跳转第N页',
        desc: '问答环节快速跳回某页，不用逐页翻',
        codes: ['数字', 'Enter']
    },
    {
        type: 'PPT',
        title: '放映时下一页',
        desc: '最常用的翻页方式，单手即可操作',
        codes: ['→ / Space']
    },
    {
        type: 'PPT',
        title: '放映时上一页',
        desc: '观众提问时快速返回上一页',
        codes: ['←']
    },
    {
        type: 'PPT',
        title: '原位复制对象',
        desc: '复制出的对象与原对象完全重叠，便于对齐后再移位',
        codes: ['Ctrl', 'D']
    },
    {
        type: 'PPT',
        title: '组合对象',
        desc: '将多个元素打包成一个整体，统一移动缩放',
        codes: ['Ctrl', 'G']
    },
    {
        type: 'PPT',
        title: '取消组合',
        desc: '拆开组合后单独编辑其中某个元素',
        codes: ['Ctrl', 'Shift', 'G']
    },
    {
        type: 'PPT',
        title: '循环选中页面元素',
        desc: '不用鼠标点击，逐个选中页面上所有对象',
        codes: ['Tab']
    },
    {
        type: 'PPT',
        title: '反向循环选中元素',
        desc: '反方向遍历选中对象，配合Tab使用',
        codes: ['Shift', 'Tab']
    },
    {
        type: 'PPT',
        title: '对象向后/向前一层',
        desc: '调整元素叠放顺序，解决遮挡问题',
        codes: ['Ctrl', '[ / ]']
    },
    {
        type: 'PPT',
        title: '对象移到最底/最顶层',
        desc: '一步到位，不用多次按层级调整',
        codes: ['Ctrl', 'Shift', '[ / ]']
    },
    {
        type: 'PPT',
        title: '微移对象1px',
        desc: '精细调整元素位置，比鼠标拖拽更准确',
        codes: ['方向键']
    },
    {
        type: 'PPT',
        title: '微移对象10px',
        desc: '幅度更大的位移，快速粗调位置',
        codes: ['Shift', '方向键']
    },
    {
        type: 'PPT',
        title: '水平/垂直移动对象',
        desc: '拖动时锁定方向，保证元素不跑偏',
        codes: ['Shift', '拖拽']
    },
    {
        type: 'PPT',
        title: '复制对象',
        desc: '拖动同时复制，比Ctrl+D再移动更直观',
        codes: ['Ctrl', '拖拽']
    },
    {
        type: 'PPT',
        title: '等比缩放对象',
        desc: '拖拽角点时保持宽高比，图片不变形',
        codes: ['Shift', '缩放']
    },
    {
        type: 'PPT',
        title: '复制/粘贴格式',
        desc: '把一个文本框的字体颜色等格式套用到其他对象',
        codes: ['Ctrl', 'Shift', 'C/V']
    },
    {
        type: 'PPT',
        title: '新建幻灯片',
        desc: '快速在当前页后插入新页，不用右键菜单',
        codes: ['Ctrl', 'M']
    },
    {
        type: 'PPT',
        title: '幻灯片上移/下移',
        desc: '在缩略图区快速调整页面顺序',
        codes: ['Ctrl', 'Shift', '↑/↓']
    },
    {
        type: 'PPT',
        title: '大纲视图移动段落',
        desc: '在大纲模式下整块移动内容层级',
        codes: ['Alt', 'Shift', '↑/↓']
    },
    {
        type: 'PPT',
        title: '在窗格间切换焦点',
        desc: '键盘在编辑区、缩略图区、备注区之间切换',
        codes: ['F6']
    },
    {
        type: 'PPT',
        title: '打开字体对话框',
        desc: '一次性设置字体、字号、颜色等所有属性',
        codes: ['Ctrl', 'Shift', 'F']
    },
    {
        type: 'PPT',
        title: '打开选择窗格',
        desc: '显示页面所有对象列表，解决元素被遮住点不到的问题',
        codes: ['Alt', 'F10']
    },
    {
        type: 'PPT',
        title: '文字左/居中/右对齐',
        desc: '快速调整文本框内文字的对齐方式',
        codes: ['Ctrl', 'L/E/R']
    },
    {
        type: 'PPT',
        title: '等高对齐选中对象',
        desc: '让多个对象高度一致，省去手动调整',
        codes: ['Ctrl', 'Shift', 'H']
    },
    {
        type: 'PPT',
        title: '等宽对齐选中对象',
        desc: '让多个对象宽度一致，排列更整齐',
        codes: ['Ctrl', 'Shift', 'W']
    }
];